import { Text, VStack } from "@chakra-ui/react";
import AdsReportForm from "../Ads/AdsReportForm";

const CampaignsSettings = () => {
  return (
    <VStack alignItems="stretch" spacing={6}>
      <Text fontSize="28px" fontWeight="600" alignSelf="flex-start">
        Engage settings
      </Text>
      <AdsReportForm />
    </VStack>
  );
};

export default CampaignsSettings;
